import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import { Footer } from "apps/oneOnboarding/Footer";
import { useOnboardingPageContextAtomValue } from "apps/oneOnboarding/onboardingPageContextAtom";
import { useSidebarAtomValue } from "apps/oneOnboarding/sidebar/sidebarAtom";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useFooterNavigation } from "apps/oneOnboarding/useFooterNavigation";
import type { FunctionComponent } from "react";
import { useContentPolicyValidation } from "./contract/useContentPolicyValidation";
import { useContractCheckboxValidation } from "./contract/useContractCheckboxValidation";

interface Props {
    loading: boolean;
}

export const BulkPropertyFooter: FunctionComponent<Props> = ({ loading }) => {
    const {
        cmsData: {
            common: { back, next },
            publish: { publish },
        },
    } = useStaticDataAtomValue();
    const { disablePublishing } = useOnboardingPageContextAtomValue();
    const { isSelected: isContractSigned } = useContractCheckboxValidation();
    const path = useDynamicLocation();
    const sidebarAtomValue = useSidebarAtomValue();
    const { handleBack } = useFooterNavigation();

    const isContentPolicyAgreed = useContentPolicyValidation();

    const isPublishPage = path.pathname === "/:lang/list-my-property/onboard/batch/publish";
    const isProfilePage = path.pathname === "/:lang/list-my-property/onboard/batch/profile";

    if (isProfilePage) return null;

    return (
        <Footer
            secondary={{
                type: "button",
                label: back,
                disabled: loading || sidebarAtomValue.length === 0,
                dataElementName: "bulk-onboarding-back",
            }}
            primary={{
                label: isPublishPage ? publish : next,
                disabled:
                    loading || (isPublishPage && (disablePublishing || !isContractSigned || !isContentPolicyAgreed)),
                loading: loading,
                type: "submit",
                dataElementName: "bulk-onboarding-next",
            }}
            onSecondary={handleBack}
        />
    );
};
